export const ADD_AZ = 'add_az';
export const CHANGE_AZ_DOMAIN = 'change_az_domain';
export const DELETE_AZ = 'delete_az';
export const RENAME_AZ = 'rename_az';
export const UPDATE_ENTITIES = 'update_entities';
export const MOVE_ENTITIES_TO_AZ = 'move_entities_to_az';
export const UPDATE_CONFIG = 'update_config';
